import { Link } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { Link as RouterLink } from 'react-router-dom';

import { partFinderFamilyPath } from 'partFinder/routes/routePaths';
import { IPartFinderCatalogFamily } from 'partFinder/types';
import { selectionToSearch } from 'partFinder/utils';

import { useCatalogContext } from './CatalogContext';

// The family page inherits the catalog's location and stock narrowing, and the page to return to.
export const FamilyNameCell = ({ data }: ICellRendererParams<IPartFinderCatalogFamily>) => {
  const { selection, returnTo } = useCatalogContext();

  return data ? (
    <Link
      component={RouterLink}
      to={`${partFinderFamilyPath(data.id)}${selectionToSearch(selection)}`}
      state={returnTo ? { returnTo } : undefined}
    >
      {data.name}
    </Link>
  ) : null;
};
